// Gallery
function setMain(thumb) {
  document.getElementById('mainImg').src = thumb.src;
  document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
  thumb.classList.add('active');
}

// Variant buttons
function selectVariant(btn) {
  const group = btn.closest('.variants');
  if (group) group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  updateVariantId();
}

function selectOption(btn, optionName, value) {
  const group = btn.closest('.variants');
  if (group) group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  updateVariantId();
}

function updateVariantId() {
  const select = document.getElementById('variant-select');
  if (!select) return;
  const activeButtons = document.querySelectorAll('.variants .variant-btn.active');
  const selectedValues = Array.from(activeButtons).map(b => b.textContent.trim());
  for (const option of select.options) {
    const title = option.text;
    if (selectedValues.every(v => title.includes(v))) {
      option.selected = true;
      const hiddenInput = document.getElementById('variant-id');
      if (hiddenInput) hiddenInput.value = option.value;
      break;
    }
  }
}

// FAQ accordion
function toggleFaq(btn) {
  const answer = btn.nextElementSibling;
  const icon = btn.querySelector('.faq-icon');
  const isOpen = answer.classList.contains('open');
  document.querySelectorAll('.faq-a').forEach(a => a.classList.remove('open'));
  document.querySelectorAll('.faq-icon').forEach(i => { i.textContent = '+'; });
  if (!isOpen) {
    answer.classList.add('open');
    if (icon) icon.textContent = '−';
  }
}

// Smooth scroll for anchor links
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
});

// ---- SCROLL REVEAL ----
(function initReveal() {
  // Selectors to reveal on scroll, with stagger within grids
  const revealGroups = [
    { selector: '.why-card',    stagger: 0.09 },
    { selector: '.spec-card',   stagger: 0.07 },
    { selector: '.review-card', stagger: 0.09 },
    { selector: '.step',        stagger: 0.12 },
    { selector: '.photo-grid img', stagger: 0.05 },
  ];

  // Single elements that reveal individually
  const revealSingles = [
    '.section-eyebrow',
    '.section-title',
    '.section-sub',
    '.faq-item',
    '.product-grid',
  ];

  function applyReveal(el, delay) {
    el.classList.add('reveal');
    if (delay) el.style.transitionDelay = delay + 's';
  }

  revealGroups.forEach(({ selector, stagger }) => {
    document.querySelectorAll(selector).forEach((el, i) => {
      // Figure out index within its immediate parent grid for stagger
      const siblings = el.parentElement ? Array.from(el.parentElement.querySelectorAll(selector)) : [];
      const idx = siblings.indexOf(el);
      applyReveal(el, idx * stagger);
    });
  });

  revealSingles.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => applyReveal(el, 0));
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
})();

// ---- ANIMATED HEX BACKGROUND CANVAS ----
(function initHexCanvas() {
  const canvas = document.getElementById('hex-canvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');

  // Pointy-top hexagon geometry
  const R     = 38;
  const COL_W = R * Math.sqrt(3);  // horizontal spacing
  const ROW_H = R * 1.5;           // vertical spacing

  let W, H, hexes = [];

  function resize() {
    W = canvas.width  = window.innerWidth;
    H = canvas.height = window.innerHeight;
    buildGrid();
  }

  function buildGrid() {
    hexes = [];
    const cols = Math.ceil(W / COL_W) + 3;
    const rows = Math.ceil(H / ROW_H) + 3;

    for (let row = -1; row <= rows; row++) {
      for (let col = -1; col <= cols; col++) {
        const cx = col * COL_W + (row % 2 !== 0 ? COL_W / 2 : 0);
        const cy = row * ROW_H;
        const isGlowing = Math.random() < 0.09;

        hexes.push({
          cx, cy,
          baseAlpha: 0.028 + Math.random() * 0.032,
          isGlowing,
          phase:        Math.random() * Math.PI * 2,
          speed:        0.004 + Math.random() * 0.008,
          flickerTimer: Math.floor(Math.random() * 500),
          // Rare "bright pop" hexes
          isBright: Math.random() < 0.02,
        });
      }
    }
  }

  function hexPath(cx, cy, r) {
    ctx.beginPath();
    for (let i = 0; i < 6; i++) {
      const a = (i * Math.PI) / 3 - Math.PI / 2; // pointy-top
      i === 0
        ? ctx.moveTo(cx + r * Math.cos(a), cy + r * Math.sin(a))
        : ctx.lineTo(cx + r * Math.cos(a), cy + r * Math.sin(a));
    }
    ctx.closePath();
  }

  function drawHex(h, glowFactor) {
    const alpha = Math.min(h.baseAlpha + glowFactor * 0.18, 0.22);

    if (glowFactor > 0.05) {
      ctx.shadowBlur  = 18 * glowFactor;
      ctx.shadowColor = `rgba(185,218,255,${glowFactor * 0.65})`;
    } else {
      ctx.shadowBlur = 0;
    }

    ctx.strokeStyle = `rgba(210,232,255,${alpha})`;
    ctx.lineWidth   = 0.75;
    hexPath(h.cx, h.cy, R - 2);
    ctx.stroke();
    ctx.shadowBlur = 0;
  }

  function animate() {
    ctx.clearRect(0, 0, W, H);

    for (const h of hexes) {
      if (h.isGlowing) {
        h.phase += h.speed;
        const t = (Math.sin(h.phase) + 1) / 2;  // 0–1 smooth pulse
        const glow = h.isBright ? t * 0.9 : t * 0.55;
        drawHex(h, glow);

        // Retire after 1.5 cycles
        if (h.phase > Math.PI * 2 * 1.5 && Math.random() < 0.003) {
          h.isGlowing      = false;
          h.flickerTimer   = 150 + Math.floor(Math.random() * 800);
        }
      } else {
        h.flickerTimer--;
        if (h.flickerTimer <= 0) {
          h.isGlowing = true;
          h.phase     = 0;
          h.speed     = h.isBright
            ? 0.018 + Math.random() * 0.01
            : 0.005 + Math.random() * 0.007;
        } else {
          drawHex(h, 0);
        }
      }
    }

    requestAnimationFrame(animate);
  }

  resize();
  window.addEventListener('resize', () => { resize(); });
  animate();
})();
